<template>
  <div class="percent-circle">
    <span class="circle"><slot></slot></span>
  </div>
</template>

<script>
export default {
  name: 'PercentCircle'
}
</script>

<style lang="scss" scoped>
.percent-circle {
  margin: 19px 0;
}
.circle {
  background-color: $c-red;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  color: white;
  margin: 0 auto;
  text-align: center;
  font-size: 60px;
  font-weight: $fw-bold;
  color: white;
  line-height: 1;
  padding-top: 41px;
  display: inline-block;
}
</style>
